import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { getNavigationLabelDefaults } from "./navigationLabelDefaults";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const email = "support@dreamcraft.co.kr";

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.brandArea}>
          <img
            src="/assets/images/wide_logo.png"
            alt="AUTOVID wide logo"
            width={150}
          />
          <p className={styles.copy}>{t("footer.copyright")}</p>
        </div>

        <div className={styles.infoArea}>
          <div className={styles.companyInfo}>
            <span>{t("footer.company_name")}</span>
            <span>{t("footer.representative")}</span>
            <span>{t("footer.business_number")}</span>
            <span>{t("footer.mail_order_number")}</span>
            <span>{t("footer.address")}</span>
            <span>
              {t("footer.email_label")}: {email}
            </span>
          </div>

          <div className={styles.linkRow}>
            <Link to={`/${currentLang}/blog`} className={styles.footerLink}>
              {getNavigationLabelDefaults(currentLang).blog}
            </Link>
            <Link to={`/${currentLang}/updates`} className={styles.footerLink}>
              {getNavigationLabelDefaults(currentLang).updates}
            </Link>
            <Link to={`/${currentLang}/support`} className={styles.footerLink}>
              {t("footer.support", {
                defaultValue: currentLang.toLowerCase().startsWith("ko")
                  ? "고객지원"
                  : "Support",
              })}
            </Link>
            <Link to={`/${currentLang}/faq`} className={styles.footerLink}>
              {t("footer.faq", { defaultValue: "FAQ" })}
            </Link>
            <Link
              to={`/${currentLang}/sample-videos`}
              className={styles.footerLink}
            >
              {t("footer.sample_videos", {
                defaultValue: currentLang.toLowerCase().startsWith("ko")
                  ? "예시 결과 영상"
                  : "Sample Videos",
              })}
            </Link>
            <Link
              to={`/${currentLang}/privacy-policy`}
              className={styles.footerLink}
            >
              {t("footer.privacy_policy")}
            </Link>
            <Link
              to={`/${currentLang}/terms-of-service`}
              className={styles.footerLink}
            >
              {t("footer.terms_of_service")}
            </Link>
            <Link
              to={`/${currentLang}/refund-policy`}
              className={styles.footerLink}
            >
              {t("footer.refund_policy", {
                defaultValue: currentLang.toLowerCase().startsWith("ko")
                  ? "환불정책"
                  : "Refund Policy",
              })}
            </Link>
            <Link
              to={`/${currentLang}/ai-content-policy`}
              className={styles.footerLink}
            >
              {t("footer.ai_content_policy", {
                defaultValue: currentLang.toLowerCase().startsWith("ko")
                  ? "AI 콘텐츠 정책"
                  : "AI Content Policy",
              })}
            </Link>
            <Link
              to={`/${currentLang}/support?type=partnership`}
              className={styles.footerLink}
            >
              {t("footer.partnership_inquiry")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
